import styled from 'styled-components';

export const WidgetIcon = styled.span`
  display: flex;
  align-items: center;
  margin: -8px 0 -10px -10px;
`;
